import React, { useState, useEffect } from 'react';

type DelayProps = {
  wait: number;
  children: React.ReactNode;
};

export const Delay: React.FC<DelayProps> = ({ wait, children }: DelayProps) => {
  const [isShown, setIsShown] = useState(wait === 0);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsShown(true);
    }, wait);

    return () => clearTimeout(timeout);
  }, [wait]);
  return isShown ? <>{children}</> : null;
};
export default Delay;
